var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62575 12.0088C1.72917 10.5864 3.1516 9.16394 3.1516 9.16394L7.30389 5.01164C8.41489 3.90064 10.2162 3.90064 11.3272 5.01164L12.3975 6.08197M12.3975 6.08197C12.3975 6.08197 12.7372 6.42172 14.5312 8.21564C16.3251 10.0096 14.057 12.0088 12.1604 10.1122C11.2631 9.21491 10.7903 8.74213 10.5412 8.49304C10.3634 8.3152 10.1639 8.31555 9.98608 8.49339L5.0482 13.4313C5.0482 13.4313 4.57406 15.3279 6.94479 15.3279C6.94481 17.6986 8.84139 17.2245 8.84139 17.2245C8.84139 17.2245 8.8414 19.5952 10.738 19.1211C10.738 20.5435 12.1604 22.4401 14.057 20.5435C15.3263 19.2742 19.1441 15.4565 21.5306 13.0699C22.6416 11.9589 22.6394 10.1599 21.5284 9.04889L17.4911 5.01164C16.3801 3.90064 14.5788 3.90064 13.4678 5.01164L12.3975 6.08197Z",
    stroke: "#525355",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.b5d79b7bdf9ff489c5a7293178af8db1.svg";
export { ForwardRef as ReactComponent };